import UserPortal from './userportal.container';

export default UserPortal;



// WEBPACK FOOTER //
// ./src/userportal/index.js